import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetWorkspacesListQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  page: Types.PageInput;
}>;


export type GetWorkspacesListQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, workspaces: { __typename?: 'WorkspaceConnection', nodes: Array<{ __typename?: 'Workspace', id: string, name: string, projectCount?: number | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };


export const GetWorkspacesList = /*#__PURE__*/ gql`
    query GetWorkspacesList($accountId: ID!, $page: PageInput!) {
  account(accountId: $accountId) {
    id
    workspaces(page: $page, order: {direction: ASC, field: NAME}) {
      nodes {
        id
        name
        projectCount
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ` as unknown as DocumentNode<GetWorkspacesListQuery, GetWorkspacesListQueryVariables>;

          

          export const useGetWorkspacesListQuery = (options?:QueryHookOptions<GetWorkspacesListQuery, GetWorkspacesListQueryVariables>) => useQuery(GetWorkspacesList, options);

          

          export type GetWorkspacesListQueryOptions = QueryHookOptions<GetWorkspacesListQuery, GetWorkspacesListQueryVariables>;

          

          export const useGetWorkspacesListLazyQuery = (options?:LazyQueryHookOptions<GetWorkspacesListQuery, GetWorkspacesListQueryVariables>) => useLazyQuery(GetWorkspacesList, options);

          

          export type GetWorkspacesListQueryResult = ReturnType<typeof useGetWorkspacesListQuery>;

          
